import ajax from '../utils/ajax';
import ApplyPromoCodeFailureReason from './ApplyPromoCodeFailureReason';

interface ApplyPromoCodeResponse {
  isSuccessful: boolean;
  errorMessage: string;
  reason: ApplyPromoCodeFailureReason;
}

interface RemovePromoCodeResponse {
  isSuccessful: boolean;
  errorMessage: string;
}

function apply(promoCode: string) {
  return ajax.post('/api/session/promo', { promoCode }) as Promise<ApplyPromoCodeResponse>;
}

function remove() {
  return ajax.delete('/api/session/promo') as Promise<RemovePromoCodeResponse>;
}

export default {
  apply,
  remove,
};
